// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ClientOnboarderRequest } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/ClientOnboarder';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useClientOnboarderServiceRequests: () => UseQueryResult<
  TemplateContract<ClientOnboarderRequest>[],
  string
> = () =>
  useOperatorBasedQuery('queryClientOnboarderServiceRequests', (ledgerApi, offset, operator) =>
    ledgerApi.queryClientOnboarderServiceRequests(offset, operator),
  );

export default useClientOnboarderServiceRequests;
